import { API_URL, getApiUrl } from '@/utils/api';
import ApiBase from './ApiBase';

export default class ConfigService extends ApiBase {
  static baseUrl = getApiUrl(API_URL.ADMIN);

  getFromKey(key: string) {
    const params = new URLSearchParams({ key });

    return this.api.getJSON(`${ConfigService.baseUrl}/config/bykey?${params.toString()}`);
  }
}
